export const SAVE_CHAT_STYLES = 'SAVE_CHAT_STYLES';
